import React from 'react';
import TablaBarrios from '../../components/tables/Barrios';

const Barrios = () => {
    return (
        <TablaBarrios/>
    );
}
 
export default Barrios;